const accordionElements = document?.querySelectorAll(".accordion-wrapper");
accordionElements?.forEach((item) => {
  const accordionHeader = item?.querySelector(".accordion-header");
  accordionHeader?.addEventListener("click", function () {
    item?.classList?.toggle("active");
  });
});
